$(document).ready(function () {

  var coverage, undertone, shade, variant;
  var shade_match = JSON.parse(document.querySelector('#shade-match').textContent);

  $(".single-selection").click(function (e) {
    $(this)
      .closest(".optionBox")
      .find(".single-selection")
      .removeClass("active");
    $(this).addClass("active");

    

    var name = $(this).find("input").data("result");
    if (name != undefined) {
      updateResults();
    }
    
  });

  function updateResults() {

    let quiz_result_url_location = '/pages/quiz-result-lip/';
    let split_test_result_url_location = document.body.getAttribute('data-quiz-result-lip-location');

    if (split_test_result_url_location) {
      if (split_test_result_url_location.length > 0) {
        quiz_result_url_location = split_test_result_url_location;
      }
    }

    const savedchangesAsGottenOlder = JSON.parse(localStorage.getItem("changesAsGottenOlder")) || [];
    const optionsForFrustratingUrl = savedchangesAsGottenOlder.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

    const savedSelectedDealingIssues = JSON.parse(localStorage.getItem("selectedDealingIssues")) || [];
    const optionsForDealingUrl = savedSelectedDealingIssues.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

    //console.log("Separated issues result: ", optionsForFrustratingUrl);
    //console.log("Separated Dealing result: ", optionsForDealingUrl);

    $("#quiz_result_url").val(`https://${window.location.hostname}${quiz_result_url_location}${optionsForFrustratingUrl}`);

  }

  $(".multi-selection").click(function (e) {
    const $tabGroup = $(this).closest(".question-Box"); // Use .question-Box as the container
    const maxActiveTabs = $tabGroup.attr("max-active-tabs") ? parseInt($tabGroup.attr("max-active-tabs"), 15) : 15;
    const $activeTabs = $tabGroup.find(".multi-selection.active");
  
    // Toggle active state
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      // Only add active if max limit is not reached
      if ($activeTabs.length < maxActiveTabs) {
        $(this).addClass("active");
      }
    }
  
    // Check active count and disable/enable tabs as needed
    if ($tabGroup.find(".multi-selection.active").length >= maxActiveTabs) {
      $tabGroup.find(".multi-selection:not(.active)").addClass("disabled");
    } else {
      $tabGroup.find(".multi-selection.disabled").removeClass("disabled");
    }

    var name = $(this).find("input").data("result");
    if (name != undefined) {
      updateResults();
    }
  });
  
  

  $(".comn-btn").click(function (e) {
    $("html, body").animate({ scrollTop: 0 }, "slow"); 

    if ($(this).closest(".changes-as-gotten-older")) {
      let changesAsGottenOlder = [];

      $('.changes-as-gotten-older .active input').each(function() {
        changesAsGottenOlder.push($(this).val());
      });


      // if (changesAsGottenOlder.includes("I haven’t noticed any changes")) {
      //   changesAsGottenOlder = ["Thinning lips"];
      // }

      // changesAsGottenOlder = changesAsGottenOlder.slice(0, 3);
      changesAsGottenOlder = [...new Set(changesAsGottenOlder)];
      localStorage.setItem("changesAsGottenOlder", JSON.stringify(changesAsGottenOlder));
    }



    if ($(this).hasClass('btn_final')) {
      //console.log('btn_final');
      return;
    }

    if (
      $(this)
        .closest(".step-5 .optionBox")
        .find(".single-selection")
        .hasClass("active")
    ) {
      $(this).closest(".question-Box").hide();
      $(".step-6").show();
      stepDataLayer(this);
    } else if ($(this).hasClass("shade-help")) {
      var selectedUndertone = this.getAttribute('data-undertone-value');

      if (selectedUndertone) {
        $(`[data-result="question_5"][data-value="${selectedUndertone}"]`)
        .attr("checked", "checked");
        undertone = selectedUndertone;
        updateResults();
      }

      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if ($(this).hasClass("novalidate")) {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if (this.getAttribute('data-quiz-step') === '0') {
      //console.log('Step 0');
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else {
      if (
        $(this)
          .closest(".optionBox")
          .find(".single-selection, .multi-selection")
          .hasClass("active")
      ) {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").next(".question-Box").fadeIn();
        stepDataLayer(this);
      } else {
        $(this).closest(".mob-bottom").find(".error-msg").fadeIn();
      }
    }

    // $(this)
    //   .closest(".question-Box")
    //   .next(".question-Box")
    //   .find(".optionbox-row")
    //   .removeClass("active");
    progress();
  });

  $(".pop-nextBtn").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(".step-6").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".nextSelection").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(this).closest(".question-Box").next(".question-Box").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".btn-back").click(function () {
    if ($(this).closest(".question-Box").hasClass("step-6")) {
      if (
        $(this)
          .parents()
          .find(".step-3")
          .find(".coverage-row")
          .hasClass("active")
      ) {
        $(".question-Box.step-5").show();
        $(".question-Box.step-6").hide();
      } else {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").prev(".question-Box").fadeIn();
        $(".error-msg").hide();
        progress();
        $(".pop-body").fadeOut();
      }
    } else {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").prev(".question-Box").fadeIn();
      $(".error-msg").hide();
      progress();
      $(".pop-body").fadeOut();
      $(".colorlight, .colordark").show();
    }
    if ($(this).closest('.question-Box').prev('.question-Box').hasClass('step-1')) $('.banner-quiz').show();
  });

  $('[data-result="question_5"]').change(function(e) {
    $("#" + this.getAttribute('data-value') + "-popup").fadeIn();
  });

  $(".get-popup1").click(function (e) {
    $("#cool-popup").fadeIn();
  });

  $(".get-popup2").click(function (e) {
    $("#warm-popup").fadeIn();
  });

  $(".get-popup3").click(function (e) {
    $("#neutral-popup").fadeIn();
  });

  $(".closePop").click(function (e) {
    $(".pop-body").fadeOut();
  });

  var quizForm = document.querySelector('#quiz-form');
  if (quizForm) {
    quizForm.addEventListener('submit', formSubmit);
  }

  initLogosSlider();
});

function formSubmit(evt) {
  evt.preventDefault();
  //console.log('formSubmit');

  const properties = {};
  const formData = new FormData(this);

  // First loop to collect form data
for (const [key, value] of formData.entries()) {
  // Check if the key already exists in properties
  if (properties[key]) {
    if (Array.isArray(properties[key])) {
      properties[key].push(value.toString()); // Ensure all values are strings
    } else {
      properties[key] = [properties[key].toString(), value.toString()];
    }
  } else {
    properties[key] = value.toString(); // Store as a string initially
  }
}

// Create a new object to store labeled options
const labeledProperties = {};

// Iterate over all keys to handle radio and checkbox inputs dynamically
Object.keys(properties).forEach((key) => {
  if (Array.isArray(properties[key])) {
    // Add dynamic "Option" labels only if there are multiple values
    if (properties[key].length > 1) {
      properties[key].forEach((item, index) => {
        labeledProperties[`${key} Option ${index + 1}`] = item;
      });
    }
    // Do not add the original key if it is an array with multiple values
  } else {
    // Store single values as strings without adding "Option" labels
    labeledProperties[key] = properties[key];
  }
});



// Replace `properties` with the updated `labeledProperties` directly
Object.keys(properties).forEach((key) => {
  delete properties[key]; // Clear the original properties object
});

// Assign new data back to `properties`
Object.keys(labeledProperties).forEach((key) => {
  properties[key] = labeledProperties[key];
});

  // Store the email in localStorage
  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    localStorage.setItem("quizUserEmail", properties.email); // Store valid email in localStorage
  } else {
    localStorage.setItem("quizUserEmail", ''); // Set empty string if no email is present or invalid
  }


  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    document.body.classList.add('loading');
    $('.quiz-email__error').hide();
    
    abstractEmail(properties.email)
      .then(response => response.json())
      .then(response => {
        if (response.deliverability === "DELIVERABLE") {
          klaviyoIdentify(properties);
        } else {
          identifyCallback(properties.email);
        }
      });
  } else {
    if ($('.quiz-email__input').val() == '') {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Enter your email above');

    } else if ($('.quiz-email__input').val() != '' && !isEmail($('.quiz-email__input').val())) {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Please enter valid email address');
    }
    return false;
  }
  
  console.log('properties', properties);

}

function abstractEmail(email) {
  const options = {method: 'GET'};
  const ABSTRACT_API_KEY = '271838bd67234b17906a3c1f580b10a6';
  const requestURL = `https://emailvalidation.abstractapi.com/v1?api_key=${ABSTRACT_API_KEY}&email=${email}`;
  const abstractRequest = fetch(requestURL, options)
    .catch(err => console.error(err));
  
  return abstractRequest;
}

async function klaviyoIdentify(properties) {
  let companyID = 'WVhPzg';
  let listID = 'Xz7JqP';

  if (window.location.hostname === 'fieracosmetics.co.uk') {
    companyID = 'WVhPzg';
    listID = 'UAYP6k';
  } else if (window.location.hostname === 'fieracosmetics.com') {
    companyID = 'HEyw3X';
    listID = 'Xz7JqP';
  }

  const options = {
    method: 'POST',
    headers: {revision: '2025-01-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'LipPlumperQuiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: properties.email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list', id: listID
            }
          }
        }
      }
    })
  };

  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyID}`, options);
  } catch (error) {
    console.error(error);
  } finally {
    identifyCallback(properties.email);
  }
}

function identifyCallback(email) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "quiz_lead",
    email: email
  });

  if (window.TriplePixel) {
    TriplePixel("Contact", {email: email});
  }

  let quiz_result_url_location = '/pages/quiz-result-lip/';
  let split_test_result_url_location = document.body.getAttribute('data-quiz-result-lip-location');

  if (split_test_result_url_location) {
    if (split_test_result_url_location.length > 0) {
      quiz_result_url_location = split_test_result_url_location;
    }
  }

  // window.location.href = '/pages/quiz-result/' + shade_name.toLowerCase() + '+' + shade_id + '+' + coverage;
  const savedchangesAsGottenOlder = JSON.parse(localStorage.getItem("changesAsGottenOlder")) || [];
  const optionsForFrustratingUrl = savedchangesAsGottenOlder.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

  //console.log("Separated issues: ", optionsForFrustratingUrl);
  //console.log("Separated Dealing: ", optionsForDealingUrl);


  document.body.classList.remove('loading');
  $('.success_msg').show();
  setTimeout(() => {
    window.location.href = `${quiz_result_url_location}${optionsForFrustratingUrl}`;
  }, 1000);

}

function stepDataLayer(button) {
  const stepNumber = button.getAttribute('data-quiz-step');
  const stepQuestion = button.getAttribute('data-quiz-question');

  //console.log('stepNumber', stepNumber);
  //console.log('stepQuestion', stepQuestion);

  if (stepNumber && stepQuestion) {
    window.dataLayer = window.dataLayer || [];
    const dataLayerObject = {
      event: "quiz_progress",
      step: stepNumber,
      question: stepQuestion
    };
    if (parseInt(stepNumber, 10) >= 1) $(".banner-quiz").hide();
    else $(".banner-quiz").show();
    dataLayer.push(dataLayerObject);
  }
}

function progress() {
  var progressVal = $(".question-Box:visible").attr("data-wdth");
  $(".prgress-1").css("width", progressVal + "%");
  if (progressVal == 98) {
    progressbar();
  }
}

var id = 0;
function progressbar() {
  var elem = document.getElementById("analyzeProgress");
  var width = 1;
  id = setInterval(frame, 60);
  function frame() {
    if (width >= 100) {
      clearInterval(id);
      window.setTimeout(function () {
        $(".step-8").hide();
        $(".step-9").fadeIn();
      }, 100);
    } else {
      width++;
      elem.style.width = width + "%";
    }

    $(".progVal").html(width + "%");
  }
}


function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function initLogosSlider() {
  //console.log('initLogosSlider()');
  const swiper = new Swiper('#quiz-logos-swiper', {
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 0
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    centeredSlides: false,
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      400: {
        slidesPerView: 4
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      700: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      750: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      850: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      950: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      1050: {
        slidesPerView: 7,
        spaceBetween: 10
      }
    }
  });
  
}
